Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-ajax-buttons', function (envelope) {

        var $context = envelope.message.data.context,
            $control = $('.js-product-details-ajax-buttons', $context);

        if ($control.length < 1)
            return;

        $control.on('click', '.js-add-to-cart', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            if ($this.hasClass('disabled') || $this.is(':disabled'))
                return;
            if ($('.x-warehouse-selector-widget').trigger('addtocart').hasClass('opening'))
                return;

            if ($this.hasClass('has-add-on-products')) {
                AddOnProductsToCart();
                return;
            }
               
            var state = Vendd.Product.Controller.getState();
            var id = state.parentId,
                skuId = state.selectedId,
                colorId = state.selectedColorId,
                path = state.path,
                qty = (state.qty ? stringToNumber(state.qty) : null) || 1,
                extraAttributes = [],
                bundleItems = state.bundleItems,
                recipeItems = state.recipeItems,
                comboItems = state.comboItems;

            $('.x-editable-extra-properties .editable-attribute').each(function (el) {
                var $attr = $(this);
                var code = $attr.data('attribute');
                var value = $('input', $attr).val();
                extraAttributes.push({ code: code, value: value });

            });
            var itemInfo = {
                minQuantity: state.minQuantity,
                maxQuantity: state.maxQuantity,
                quanta: state.quanta
            };

            if ($this.parents('.x-quantity-special-prices').length > 0) {
                qty = $this.data('quantity');
            }

            var enhancedInfo = { color: '', size: '', list: 'productDetails', colorId: colorId };

            if ($this.closest('.x-product-details-sticky-bar').length > 0) {
                $('html, body').animate({ scrollTop: 30 }, 1);
            }

            var vendd = getParentOrSelfVendd();
            vendd.MessageBus.publishAsync($control.get(0), new vendd.Cart.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo, enhancedInfo));
            //Open the widget only for template 1 of Cart Widget
            if ($('.x-cart-widget').data('template') === 1) {
                Vendd.MessageBus.publishAsync($wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
            }
        });

        $control.on('click', '.js-add-to-wishlist', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            if ($this.closest('.wishlist-button').hasClass('x-disabled'))
                return;

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId,
                skuId = state.selectedId,
                path = state.path,
                qty = (state.qty ? stringToNumber(state.qty) : null) || 1,
                extraAttributes = [],
                bundleItems = state.bundleItems;

            if (LhApp.Context.MultipleWishlistsEnabled && $('.x-user-wishlists', $control).length > 0) {
                UserWishlist.HideAllProductWishlists();
                UserWishlist.ShowProductWishlists($('.x-user-wishlists', $control).get(0));
            } else {
                Vendd.MessageBus.publishAsync($control.get(0), new Vendd.Wishlist.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems));
            }
        });

        $control.on('click', '.js-remove-from-wishlist', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            if ($this.closest('.wishlist-button').hasClass('x-disabled'))
                return;

            var state = Vendd.Product.Controller.getState();
            var skuId = state.selectedId;
            var wishlistModel = JSON.parse(localStorage.getItem("CurrentWishlistModel"));
            var selectedsku = wishlistModel.Items.find(function (item) { return skuId === item.VariantId });
            var wishlistItemId = selectedsku.Id;

            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.Wishlist.Messages.Remove(wishlistItemId));
        });

        $control.on('click', '.js-show-recipe', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            if ($this.hasClass('disabled') || $this.is(':disabled'))
                return;

            $this.addClass('active');

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId,
                skuId = state.selectedId,
                path = state.path,
                qty = (state.qty ? stringToNumber(state.qty) : null) || 1,
                extraAttributes = [],
                bundleItems = state.bundleItems;

            var vendd = getParentOrSelfVendd();
            vendd.MessageBus.publishAsync($control.get(0), new vendd.Recipe.Messages.GetModel(id));
        });

        $control.on('click', '.js-add-to-compare', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if ($(this).closest('.compare-button').hasClass('x-disabled'))
                return;

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId,
                skuId = state.selectedId;

            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.ProductCompare.Messages.Add(id, skuId));

            if ($('.x-productcompare-widget').data('template') === 1) {
                vendd.MessageBus.publishAsync($control.get(0), new vendd.Widget.Messages.OpenWidget(vendd.Widget.ProductCompareWidget, false));
            }
        });

        $control.on('click', '.js-remove-from-compare', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), $product, compareItemtId;

            if ($this.closest('.compare-button').hasClass('x-disabled'))
                return;

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId;

            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.ProductCompare.Messages.Remove(id));
        });

        $control.on('click', '.js-quick-view', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            if ($this.hasClass('disabled') || $this.is(':disabled'))
                return;

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId,
                skuId = state.selectedId,
                path = state.path,
                qty = ($('input[name="qty"]').val() ? stringToNumber($('input[name="qty"]').val()) : null) || 1;

            extraAttributes = "";

            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.Cart.Messages.Add(id, skuId, path, qty, extraAttributes));
            //Open the widget only for template 1 of Cart Widget
            if ($('.x-cart-widget').data('template') === 1) {
                Vendd.MessageBus.publishAsync($wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
            }
            var path = $('.x-product-details').data('path');
            var Href = '/pages/productdetailspopup.aspx?iid=' + id + '&path=' + path + '&Quantity=' + qty;
            $.fancybox.open({
                href: Href,
                type: 'iframe',
                maxWidth: 1040,
                //maxHeight: 745,
                fitToView: false,
                //width: '100%',
                //height: '100%',
                autoSize: false,
                closeClick: false,
                openEffect: 'none',
                closeEffect: 'none',
                padding: 0,
                beforeShow: function () {
                    this.width = ($('.fancybox-iframe').contents().find('.product-details-popup').width());
                    this.height = ($('.fancybox-iframe').contents().find('html').height());
                }
            });
        });

        $control.on('click', '.js-add-sku-to-cart', function (e) {

            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                $box, $qty, $tooltip,
                id, skuId, path, qty, extraAttributes, bundleItems;

            if ($this.hasClass('disabled') || $this.is(':disabled'))
                return;

            $box = $this.closest('.sku-product-box');
            $tooltip = $('.js-tooltip', $box);
            $qty = $('.js-qty-input', $box);

            id = $box.data('productid');
            skuId = $box.data('variantid');
            path = $box.data('path');

            qty = ($qty.val() ? stringToNumber($qty.val()) : null) || 0;
            extraAttributes = [];
            bundleItems = [];
            recipeItems = [];
            comboItems = [];

            if ($this.hasClass('inactive')) {
                $tooltip.addClass('visible');
                setTimeout(function () {
                    $tooltip.removeClass('visible');
                }, 3000);
                return;
            }

            var itemInfo = {
                minQuantity: parseInt($box.data('min-quantity') || 0),
                maxQuantity: parseInt($box.data('max-quantity') || 0),
                quanta: parseInt($box.data('quanta') || 0)
            };

            var state = Vendd.Product.Controller.getState();
            var enhancedInfo = { color: '', size: '', list: 'productDetails', colorId: state.selectedColorId };


            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Cart.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo, enhancedInfo));
            //Open the widget only for template 1 of Cart Widget
            if ($('.x-cart-widget').data('template') === 1) {
                Vendd.MessageBus.publishAsync($wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
            }
        });

        $control.on('click', '.js-notify-button', function (e) {

            var $this = $(this);
            var $productWrapper = $('.x-product-details'),
                $availabilityForm = $('.x-product-details-availability-notification', $productWrapper);

            if ($productWrapper.length < 1)
                return;

            if ($availabilityForm.hasClass('hidden')) {
                $availabilityForm.removeClass('hidden');
            } else {
                $availabilityForm.addClass('hidden');
            }
        });

        $(document).on('click', function (e) {
            var $productWrapper = $('.x-product-details'),
                $availabilityForm = $('.x-product-details-availability-notification', $productWrapper),
                $notifyBtn = $('.js-notify-button', $productWrapper);
            if (!$availabilityForm.is(e.target)
                && $availabilityForm.has(e.target).length === 0
                && !$notifyBtn.is(e.target)
                && $notifyBtn.has(e.target).length === 0) {

                $availabilityForm.addClass('hidden');
            }
        });

        function AddOnProductsToCart() {

            var dataArray = [], dataAddOns = [], data;
            var state = Vendd.Product.Controller.getState();

            //get add ons info
            var $addOns = $('.x-product-details-add-ons', $context);
            var $selectedAddOns = $addOns.find(':checked') || $addOns.find(':selected').not("val");

            $.each($selectedAddOns, function (i, addOn) {
                $addOn = $(addOn);

                if ($addOn.data('sku-id')) {
                    data = {
                        id: $addOn.data('parent-id'),
                        skuId: $addOn.data('sku-id'),
                        path: $addOn.data('path'),
                        qty: stringToNumber(1),
                        isAddOnOf: state.selectedId
                    };
                    dataArray.push(data);
                    //set an array with addons
                    dataAddOns.push($addOn.data('sku-id'));
                }
            });

            //get product info
            data = {
                id: state.parentId,
                skuId: state.selectedId,
                path: state.path,
                qty: (state.qty ? stringToNumber(state.qty) : null) || 1,
                isBaseOf: dataAddOns
            };
            //unshift is used in order to push base product first
            dataArray.unshift(data);

            if (!dataArray || !dataArray.length)
                return;

            var vendd = getParentOrSelfVendd();
            vendd.MessageBus.publishAsync($control.get(0), new Vendd.Cart.Messages.MultipleAdd(dataArray));

        }
    });

});

